/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

/** Get the unified event timeline of a patient (pro/patient/admin access). */
export const getPatientTimeline = async (patientId, { limit = 100 } = {}) =>
  (await api.get(`/patients/${patientId}/timeline`, { params: { limit } })).data;
